import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  datePicker: {
    width: "100%",
    // marginLeft: "35px",
    display: "flex",
    backgroundColor: "#F8F9FC",
    borderRadius: 10,
    padding: "10px 15px"
    // "@media screen and (max-width: 1024px)": {
    //   marginLeft: "0",
    //   marginTop: "10px"
    // }
  },
  timePaper: {
    width: 540,
    backgroundColor: "#F8F9FC",
    borderRadius: 10,
    padding: "16px",
    marginTop: 16,
    fontSize: 14,
    fontWeight: 400,
    color: "#333",
    display: "flex",
    flexDirection: "column",
    gap: "8px"
  },
  excuteTime: {
    display: "flex",
    alignItems: "center",
    position: "relative"
  },
  displayContent: {
    width: 240,
    height: 354,
    backgroundColor: "#F8F9FC",
    borderRadius: 6,
    border: "none",
    padding: 16
  }
}));

export default useStyles;
